import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
} from '@angular/core';

@Component({
  selector: 'app-collapse-card',
  templateUrl: './collapse-card.component.html',
  styleUrls: ['./collapse-card.component.scss']
})
export class CollapseCardComponent {


  @Input()
  header = 'Header'

  @ViewChild('collapseCard') elementView: ElementRef;
  viewHeight: number;

  isCollapse = false

  constructor() { }

  toggleCollapse() {
    this.isCollapse = !this.isCollapse
  }

  ngOnInit() {
  }

  ngAfterContentInit() {
    setTimeout(() => {
      this.viewHeight = this.elementView.nativeElement.offsetHeight;
    }, 1000);
  }

}
